import { CanActivateFn } from '@angular/router';

export const childTokenGuard: CanActivateFn = (route, state) => {
  if (localStorage.getItem('tokenKey') == null || localStorage.getItem('tokenKey') == undefined) {
    /* this.router.navigate(['/login']); */
    return false;
  }
  return true;
};
